import React, { useState, useEffect, useRef } from "react";
import Nav from "./Nav";
import Select from "./Select";
import "./Home.css";
import { additionLuvers, additionWindow } from "./additionSelects";
import { createNoSubstitutionTemplateLiteral } from "typescript";



function Home() {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState({} as any);
  const [selects, setSelect] = useState([]);
  const [luverSelects, setLuverSelects] = useState([]);
  const [currentCategory, setCurrentCategory] = useState("");
  const [chosenElements, setChosenElements] = useState({} as any);
  const [currentItem, setCurrentItem] = useState({} as any);
  const [konfigured, setKonfigured] = useState({
    width: 0,
    length: 0,
    window_width: 0,
    window_length: 0,
    bottom_window_distace: 0,
    left_window_distace: 0,
    right_window_distace: 0,
    top_window_distace: 0,
    top_luvers_distance: 0,
    bottom_luvers_distance: 0,
    left_luvers_distance: 0,
    right_luvers_distance: 0,
    top_right_angle: 0,
    top_left_angle: 0,
    quantity: 1,
  } as any);
  const [description, setDescription] = useState(null);
  const [mixedShowcase, setMixedShowcase] = useState(null as any);
  const [checkboxLuverSet, setCheckboxLuverSet] = useState(new Set<number>());

  const [price, setPrice] = useState({} as any);
  const [color, setColor] = useState("");

  const [drawing, setDrawing] = useState({} as any);

  const prevMixedShowcaseRef = useRef();
  let prevMixedShowcase;
  const prevItemRef = useRef();
  let prevItem: any;
  let fetchUrl: string;
  // if (process.env.NODE_ENV === "development") {
  //   fetchUrl = `api`;
  // } else {
  //   fetchUrl = `http://127.0.0.1:8000/api`;
  // }
  fetchUrl = `http://127.0.0.1:8000/api`
  // First time request
  useEffect(() => {
    setIsLoaded(false);
    fetch(fetchUrl)
      .then((res) => res.json())
      .then(
        (result) => {
          setIsLoaded(true);
          setItems(result);
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      );
  }, []);

  useEffect(() => {
    if (konfigured["top_right_angle"] > 0) {
      konfigured.top_left_angle = 0
      calculateHypotenuse(konfigured["top_right_angle"])
      setKonfigured({...konfigured})
    }
  }, [konfigured["top_right_angle"]]);

  useEffect(() => {
    if (konfigured["top_left_angle"] > 0) {
      konfigured.top_right_angle = 0
      calculateHypotenuse(konfigured["top_left_angle"])
      setKonfigured({...konfigured})
    }
  }, [konfigured["top_left_angle"]]);

  // Request then click to nav
  const onNavClickHandle = (url: string, name: string) => {
    setIsLoaded(false);
    // if (process.env.NODE_ENV === "development") {
    //   if (url !== undefined) url = url.replace("http", "https");
    // }

    fetch(url)
      .then((res) => res.json())
      .then(
        (result) => {
          setIsLoaded(true);
          setSelect(result.results);
          setCurrentCategory(name);
          // if (result.results.length === 1) {
          //   delete items[name]
          //   setItems({...items})
          // }
          if (name === "luvers") {
            setLuverSelects(result.results);
          }
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      );
  };

  useEffect(() => {
    prevItemRef.current = currentItem;
    prevMixedShowcaseRef.current = mixedShowcase;
  });
  if (prevItemRef.current !== undefined) {
    prevItem = prevItemRef.current;
  }
  if (prevMixedShowcaseRef.current !== undefined) {
    prevMixedShowcase = prevMixedShowcaseRef.current;
  }

  // Set selected current item
  useEffect(() => {
    let current;
    if (selects) {
      current = selects.find(
        (el: any) => el.id.toString() === konfigured[currentCategory]
      );
    }
    if (current === undefined) {
      current = additionLuvers.find(
        (el: any) => el.id.toString() === konfigured[currentCategory]
      );
    }
    if (current === undefined) {
      current = additionWindow.find(
        (el: any) => el.id.toString() === konfigured[currentCategory]
      );
    }

    if (current !== undefined) {
      setCurrentItem(current);
    }
  }, [selects, konfigured, currentCategory]);

  useEffect(() => {
    if (currentCategory === "parameters") {
      setSelect([]);
      setIsLoaded(true)
    }
  }, [currentCategory]);

  // Set selected current description
  useEffect(() => {
    if (currentItem.description != undefined) {
      setDescription(currentItem.description);
    }
    //Set showcase for selects after colors
    if (
      Object.keys(currentItem).length > 0 &&
      currentItem.picture_showcase === undefined
    ) {
      const findId =
        konfigured["color"] !== undefined ? konfigured["color"] : 1;
      const current = currentItem.colors.find(
        (el: any) => +el.color === +findId
      );
      if (current !== undefined) {
        // setMixedShowcase(current.picture_showcase);
        setMixedShowcase(current.picture_showcase);
      }
      if(currentCategory === "window") {
        setMixedShowcase("https://res.cloudinary.com/hdi6eolrl/" + current.image_showcase);
      }
    }
    if (
      currentCategory !== "parameters" &&
      currentCategory !== "summary" &&
      Object.keys(currentItem).length > 0
    ) {
      chosenElements[currentCategory] = currentItem;
      setChosenElements({ ...chosenElements });
    }

    if (currentCategory === "color") {
      setColor(currentItem.code);
    }
   
  }, [currentItem, currentCategory]);

  const handleSelectChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.name === "luvers" && e.target.value !== "mieszany_oczka") {
      konfigured["bottom_luvers"] = e.target.value;
      konfigured["top_luvers"] = e.target.value;
      konfigured["left_luvers"] = e.target.value;
      konfigured["right_luvers"] = e.target.value;
    }
    if (e.target.value === "mieszany_oczka") {
      konfigured["bottom_luvers"] = null;
      konfigured["top_luvers"] = null;
      konfigured["left_luvers"] = null;
      konfigured["right_luvers"] = null;
    }
    setKonfigured({ ...konfigured, [e.target.name]: e.target.value });
  };

  const setLuversCount = (count: number, name: string) => {
    konfigured[name] = count;
    setKonfigured({ ...konfigured });
  };

  useEffect(() => {
    if (konfigured["luvers"] === "BEZ_OCZEK") {
      setLuversCount(0, "top_luvers_count");
      setLuversCount(0, "left_luvers_count");
      setLuversCount(0, "right_luvers_count");
      setLuversCount(0, "bottom_luvers_count");
    }
  }, [konfigured["luvers"]]);

  const controlInnerWindow = function () {
    const leastUnitForDistances = 2;
    const controlSidesUnit = 1;
    if (konfigured["window_length"] > 0 || konfigured["windwo_width"] > 0) {
      if (
        +konfigured["window_length"] >=
        +konfigured["length"] - controlSidesUnit
      ) {
        konfigured["window_length"] =
          +konfigured["length"] - leastUnitForDistances;
      }
      if (
        +konfigured["window_width"] >=
        +konfigured["width"] - controlSidesUnit
      ) {
        konfigured["window_width"] =
          +konfigured["width"] - leastUnitForDistances;
      }
      const widthDistanse =
        (+konfigured["width"] - +konfigured["window_width"]) / 2;
      const lengthDistanse =
        (+konfigured["length"] - +konfigured["window_length"]) / 2;
      konfigured["bottom_window_distace"] = widthDistanse;
      konfigured["top_window_distace"] = widthDistanse;
      konfigured["left_window_distace"] = lengthDistanse;
      konfigured["right_window_distace"] = lengthDistanse;
      setKonfigured({ ...konfigured });
    }
  };

  const controlDistance = (
    controlingDistance: string,
    dependentDistance: string,
    side: string
  ) => {
    const calculatedDistance =
      Number(konfigured[side]) -
      Number(konfigured[dependentDistance]) -
      Number(konfigured[`window_${side}`]);
    if (calculatedDistance < 0) {
      konfigured[dependentDistance] =
        Number(konfigured[dependentDistance]) + calculatedDistance;
      setKonfigured({ ...konfigured });
      return;
    }
    konfigured[controlingDistance] = calculatedDistance;
    setKonfigured({ ...konfigured });
  };

  useEffect(() => {
    //controlTopDistance()
    controlDistance("top_window_distace", "bottom_window_distace", "width");
  }, [konfigured["bottom_window_distace"]]);

  useEffect(() => {
    controlDistance("bottom_window_distace", "top_window_distace", "width");
    // controlMaxDistance('top_window_distace', 'bottom_window_distace', 'width' )
  }, [konfigured["top_window_distace"]]);

  useEffect(() => {
    controlDistance("right_window_distace", "left_window_distace", "length");
  }, [konfigured["left_window_distace"]]);

  useEffect(() => {
    controlDistance("left_window_distace", "right_window_distace", "length");
  }, [konfigured["right_window_distace"]]);

  const screenshotHadle = (canvas: any) => {
    setDrawing(canvas);
  };

  const quantityHandle = (direction: string) => {
    let count = konfigured["quantity"];
    if (direction === "-" && count > 1) {
      count -= 1;
    }
    if (direction === "+") {
      count += 1;
    }
    setKonfigured({ ...konfigured, quantity: count });
  };

  const calculateHypotenuse = (angle: number) => {
    const hypotenuse = Math.sqrt(Math.pow(angle, 2) + Math.pow(konfigured.length, 2))
    konfigured.hypotenuse = hypotenuse;
    setKonfigured({...konfigured})
  }

  useEffect(() => {
    konfigured["area"] = +konfigured["width"] * +konfigured["length"];
    calculateHypotenuse(konfigured["top_right_angle"] || konfigured["top_left_angle"])
    setKonfigured({ ...konfigured });
  }, [konfigured["width"], konfigured["length"]]);

  useEffect(() => {
    controlInnerWindow();
  }, [konfigured["window_width"], konfigured["window_length"]]);

  useEffect(() => {
    if (chosenElements["material"] != undefined) {
      if (
        konfigured["window"] !== undefined &&
        konfigured["window"] !== "bez_okna"
      ) {
        price.material_price =
          +chosenElements["window"]["price"] * (konfigured["area"] / 10000);
      } else {
        price.material_price =
          +chosenElements["material"]["price"] * (konfigured["area"] / 10000);
      }

      setPrice({ ...price });
    }
  }, [konfigured["area"], chosenElements]);

  useEffect(() => {
    price.per_unit = price["material_price"] + price["luvers_price"];
    price.total = price["material_price"] + price["luvers_price"];
    setPrice({ ...price });
  }, [price["material_price"], price["luvers_price"]]);

  useEffect(() => {
    if (price.per_unit !== undefined) {
      price.total = 0;
      for (let i of Array(konfigured["quantity"])) {
        price.total += price.per_unit;
      }
    }
    setPrice({ ...price });
  }, [konfigured["quantity"]]);

  useEffect(() => {
    if (konfigured["luvers"] !== "mieszany_oczka") {
      const total_luvers_count =
        Number(konfigured["top_luvers_count"] || 0) +
        Number(konfigured["left_luvers_count"] || 0) +
        Number(konfigured["right_luvers_count"] || 0) +
        Number(konfigured["bottom_luvers_count"] || 0);

      if (
        chosenElements["luvers"] !== undefined &&
        chosenElements["luvers"]["price"] !== undefined &&
        chosenElements["luvers"] !== "BEZ_OCZEK"
      ) {
        price.luvers_price =
          +chosenElements["luvers"]["price"] * total_luvers_count;
        setPrice({ ...price });
      }
    }

    if (konfigured["luvers"] === "mieszany_oczka") {
      const top_luver: any = luverSelects.find(
        (el: any) => el.id === konfigured["top_luvers"]
      );
      const left_luver: any = luverSelects.find(
        (el: any) => el.id === konfigured["left_luvers"]
      );
      const right_luver: any = luverSelects.find(
        (el: any) => el.id === konfigured["right_luvers"]
      );
      const bottom_luver: any = luverSelects.find(
        (el: any) => el.id === konfigured["bottom_luvers"]
      );
      const top_price =
        konfigured["top_luvers_count"] *
        (top_luver !== undefined ? top_luver.price : 0);
      const left_price =
        konfigured["left_luvers_count"] *
        (left_luver !== undefined ? left_luver.price : 0);
      const right_price =
        konfigured["top_luvers_count"] *
        (right_luver !== undefined ? right_luver.price : 0);
      const bottom_price =
        konfigured["top_luvers_count"] *
        (bottom_luver !== undefined ? bottom_luver.price : 0);
      const total_luvers_price =
        top_price + left_price + right_price + bottom_price;
      price["luvers_price"] = total_luvers_price;
      setPrice({ ...price });
    }
  }, [
    konfigured["top_luvers_count"],
    konfigured["left_luvers_count"],
    konfigured["right_luvers_count"],
    konfigured["bottom_luvers_count"],
    konfigured["top_luvers"],
    konfigured["left_luvers"],
    konfigured["right_luvers"],
    konfigured["bottom_luvers"],
    chosenElements,
  ]);

  return (
    <div className="Home">
      <Nav items={items} onNavClickHandle={onNavClickHandle}></Nav>
      <Select
        category={currentCategory}
        showcase={currentItem.picture_showcase || mixedShowcase}
        // prevShowcase={prevItem?.picture_showcase || prevMixedShowcase}
        onSelectChange={handleSelectChange}
        selects={selects}
        luverSelects={luverSelects}
        checkboxLuverSet={checkboxLuverSet}
        konfigured={konfigured}
        isLoaded={isLoaded}
        description={description}
        setLuversCount={setLuversCount}
        chosenElements={chosenElements}
        price={price}
        drawing={drawing}
        color={color}
        screenshotHadle={screenshotHadle}
        quantityHandle={quantityHandle}
      ></Select>
    </div>
  );
}

export default Home;
